<template>
  <div :class="_['order-box']">
    <div :class="_['user-info']">
      <div>
        <span>{{ order.consigneeInfo.name }}</span>
        <span :class="_['user-phone']">{{ order.consigneeInfo.tel }}</span>
      </div>
      <div
        :class="_['order-state']"
        :style="{
          color:
            order.orderStatus == 900
              ? '#FF2438'
              : order.orderStatus == 402
              ? '#FDA202'
              : order.orderStatus == 401
              ? '#00A178'
              : '',
        }"
      >
        {{ order.orderStatusLabel }}
      </div>
    </div>
    <div :class="_['order-address']">
      {{ order.consigneeInfo.province }}{{ order.consigneeInfo.city }}市{{
        order.consigneeInfo.area
      }}区{{ order.consigneeInfo.address }}
    </div>
    <div
      v-track="{
        name: '订单管理-订单详情',
        id: 'cl9qfb7jb001akcuge7x555iz',
      }"
      :class="[_['order-info'], _._hairlineTop]"
      @click="toOrderDetaill"
    >
      <img :class="_['order-info-img']" :src="order.pic" alt="" />
      <div :class="_['order-info-details']">
        <div :class="[_['order-goods'], _._ellipsis2]">
          {{ order.commodityNames[0] }}
        </div>
        <div :class="_['order-space-more']">
          <div :class="_['order-space']">￥{{ order.orderAmount }}</div>
          <div :class="_['order-states']">
            <div
              v-if="order.saleAfterStatusLabel"
              :class="_.state"
              :style="{
                background:
                  order.saleAfterStatus == 0 ||
                  order.saleAfterStatus == 2 ||
                  order.saleAfterStatus == 3
                    ? '#F1F1F1'
                    : '',
                color:
                  saleAfterStatus == 0 ||
                  order.saleAfterStatus == 2 ||
                  order.saleAfterStatus == 3
                    ? '#999999'
                    : '',
              }"
            >
              {{ order.saleAfterStatusLabel }}
            </div>
            <span :class="_['order-more']"
              >共{{ order.commodityNames.length }}件商品</span
            >
          </div>
        </div>
      </div>
    </div>
    <div :class="_['order-bottom']">
      <div :class="_['order-date']">{{ order.orderTime }}</div>
      <div :class="_['order-btn']">
        <van-button
          v-if="order.orderStatus == 400 && order.saleAfterStatus != 1"
          v-track="{
            name: '订单管理-拒绝接单',
            id: 'cl9qf6qcl0016kcug2h6z3h0w',
          }"
          :class="_['btn-style']"
          round
          type="default"
          @click="refresh"
          >拒绝接单</van-button
        >
        <van-button
          v-if="order.orderStatus == 400 && order.saleAfterStatus != 1"
          v-track="{
            name: '订单管理-立即接单',
            id: 'cl9qf69om0014kcug04km3h42',
          }"
          :class="[_['take-orders-btn'], _['btn-style']]"
          round
          type="info"
          @click="agreeTakeOrder(order.orderNo)"
          >立即接单</van-button
        >
        <van-button
          v-if="order.orderStatus == 401 && order.saleAfterStatus != 1"
          v-track="{
            name: '订单管理-立即配送',
            id: 'cl9qfcbpf001ckcug9c535mzw',
          }"
          :class="[_['take-orders-btn'], _['btn-style']]"
          round
          type="info"
          @click="takeDelivery"
          >立即配送</van-button
        >
      </div>
      <div
        v-if="order.deliverUserInfo.serviceUserName"
        :class="_['marki-info']"
      >
        配送人员：
        <span>{{ order.deliverUserInfo.serviceUserName }}</span>
        <span :class="_['marki-phone']">{{
          order.deliverUserInfo.serviceUserTel
        }}</span>
      </div>
      <refuseSheet :show="show" @close="close" @confirmReason="confirmReason" />
    </div>

    <div v-if="order.saleAfterStatus == 1" :class="_.ordertip">
      <div></div>
      <div :class="_.txt">请到电脑端后台处理售后订单</div>
    </div>
    <div v-if="false" :class="_.refundbtn">
      <div></div>
      <div :class="_.btngroup">
        <van-button :class="_['btn-style']" round type="default"
          >拒绝退款</van-button
        >
        <van-button
          :class="[_['take-orders-btn'], _['btn-style']]"
          round
          type="info"
          >同意退款</van-button
        >
      </div>
    </div>
    <addDeliverySheet
      :order-no="order.orderNo"
      :show="showDelivery"
      @closeEmit="deliveryClose"
    />
  </div>
</template>

<script>
  import addDeliverySheet from '../components/AddDeliveryPerson.vue'
  import refuseSheet from '../components/refuseSheet.vue'
  import Vue from 'vue'
  import { apiOrderMerchantOrderReject, apiOrderMerchantOrderTake } from '@/api'
  import { newRouteOnValueChange } from '@/utils'
  import { Toast } from 'vant'

  export default Vue.extend({
    components: { refuseSheet, addDeliverySheet },
    props: {
      orderState: {
        type: Number,
        default: 0, //订单类型：0.待接单；1.待配送;2.配送中;3.已完成;4.售后/退款
      },
      order: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        show: false,
        showDelivery: false,
        radio: 1,
        orderStateTxt: ['待接单', '待配送', '配送中', '已完成', '售后/退款'],
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    methods: {
      refresh() {
        this.show = true
        newRouteOnValueChange({
          ctx: this,
          valueName: 'show',
          callback: v => {
            if (!v) {
              this.show = false
            }
          },
        })
      },
      close() {
        this.show = false
      },
      toOrderDetaill() {
        this.$emit('operation', true)
        this.$router.push({
          path: '/manage/orderdelivery/orderDetail',
          query: {
            id: this.order.orderNo,
          },
        })
      },
      //立即配送
      takeDelivery() {
        this.showDelivery = true
        newRouteOnValueChange({
          ctx: this,
          valueName: 'showDelivery',
          callback: v => {
            if (!v) {
              this.showDelivery = false
            }
          },
        })
      },
      //配送成功回调
      deliveryClose(value) {
        this.showDelivery = false
        this.$emit('operation', false, !value)
      },
      //同意接单
      async agreeTakeOrder(No) {
        Toast.loading({
          message: '接单中',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        })
        await apiOrderMerchantOrderTake({ orderNo: No }, { hasStoreCode: true })
        Toast.clear()
        Toast.success('接单成功')
        this.$emit('operation')
      },
      //拒绝接单
      async rejectTakeOrder(No, reason) {
        Toast.loading({
          message: '拒绝接单中',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        })
        await apiOrderMerchantOrderReject(
          { orderNo: No, reason: reason },
          { hasStoreCode: true },
        )
        Toast.clear()
        Toast.success('拒单成功')
        this.$emit('operation')
      },
      //拒绝弹框回调
      confirmReason(reas) {
        this.rejectTakeOrder(this.order.orderNo, reas)
        this.show = false
      },
    },
  })
</script>

<style lang="scss" module>
  .order-box {
    width: calc(100% - 24px);
    margin-top: 12px;
    padding: 12px;
    color: #222222;
    background: #ffffff;
    border-radius: 8px;
    .user-info {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      .user-phone {
        margin-left: 8px;
        color: #888888;
      }
      .order-state {
        font-weight: 500;
        color: #333333;
      }
    }
    .order-address {
      width: 257px;
      font-size: 12px;
      font-weight: 400;
      color: #222222;
      line-height: 16px;
      margin-top: 4px;
      margin-bottom: 7px;
    }
    .order-info {
      height: 70px;
      display: flex;
      padding-top: 11px;
      .order-info-img {
        width: 70px;
        height: 70px;
        background: #d8d8d8;
        border-radius: 8px;
      }
      .order-info-details {
        width: calc(100% - 76px);
        font-size: 14px;
        margin-left: 8px;
        .order-states {
          display: flex;
          align-items: center;
          .state {
            // width: 54px;
            height: 23px;
            line-height: 23px;
            text-align: center;
            background: #fff3f2;
            border-radius: 17px;
            opacity: 0.93;
            font-size: 12px;
            font-weight: 400;
            color: #ff313a;
            margin-right: 12px;
            padding: 0 10px;
          }
        }
        .order-space {
          font-size: 14px;
          font-weight: 500;
          color: #ff202a;
        }
        .order-more {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .order-space-more {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 11px;
    }
    .order-bottom {
      // height: 30px;
      padding-top: 16px;
      display: flex;
      justify-content: space-between;
      flex-flow: wrap;
      align-items: center;
      .order-btn {
        display: flex;
      }
      .marki-info {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        .marki-phone {
          margin-left: 7px;
        }
      }
      .order-date {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        flex-grow: 1;
      }
      .btn-style {
        width: 86px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #222222;
        padding: 0;
      }
      .take-orders-btn {
        background: #ff111c;
        opacity: 0.93;
        border: none;
        font-weight: 400;
        color: #ffffff;
        margin-left: 12px;
      }
    }
    .ordertip {
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      .txt {
        font-size: 12px;
        font-weight: 400;
        color: #2e7dff;
        // padding-top: 12px;
      }
    }
    .refundbtn {
      display: flex;
      justify-content: space-between;
      // margin-top: 12px;
      padding-bottom: 8px;
      .btngroup {
        height: 30px;
        .btn-style {
          width: 86px;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          font-weight: 400;
          color: #222222;
          padding: 0;
        }
        .take-orders-btn {
          background: #ff111c;
          opacity: 0.93;
          border: none;
          font-weight: 400;
          color: #ffffff;
          margin-left: 12px;
        }
      }
    }
  }
</style>
